import { ActionTree } from 'vuex';
import SentryClient from '@/helpers/sentry';
import { CourseState } from './state';
import RootState from '@/store/root_state';
import { chimeraQuery } from '@/helpers/graphql';
import { chimeraCourseSupportMaterialFilesQuery } from '../../queries/chimeraQueries';
import { CourseModel } from '@descomplica/dex-models';
import { getCourseCategory } from '@/helpers/category';
import Analytics from '@/helpers/analytics';
import { EVENT_LABELS } from '@/helpers/analytics/labels';

const actions: ActionTree<CourseState, RootState> = {
  async GET_CHIMERA_COURSE_MATERIAL_FILES(
    { commit },
    {
      chimeraCourseId,
      currentCourse,
      courseName,
    }: { chimeraCourseId: string; currentCourse: CourseModel; courseName: string },
  ) {
    try {
      const response = await chimeraQuery(chimeraCourseSupportMaterialFilesQuery, {
        courseId: chimeraCourseId,
      });

      const chimeraCourseMaterials = response.data.chimera?.course?.supportMaterialFolders ?? [];

      commit('SET_CHIMERA_COURSE_MATERIAL_FILES', { chimeraCourseMaterials, chimeraCourseId });
    } catch (e) {
      Analytics.trackEvent(EVENT_LABELS.postgradDocumentsPageError, {
        in_course: courseName,
        changed_course: currentCourse.name !== courseName,
        course: currentCourse.name,
        category: getCourseCategory(currentCourse),
      });
      SentryClient.captureError(e);
    }
  },
};

export default actions;
